
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../GardenPopup/DeletePopup'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { WTPEquipmentTypeDDLData } from '../../../../../Components/CommonDDL/WTPEquipmentTypeDDLData'
import { WTPEquipmentNameDDL } from '../../../../../Components/CommonDDL/WTPEquipmentNameDDL'
import { Loading } from '../../../../../Helper/Loading'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import { WTPMachineryChecklistDeleteAPI, WTPMachineryChecklistTableDataAPI, WTPMachineryChecklistTableExportDataAPI } from '../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/PreventiveData/MachineryChecklistSlice'
import { useAuthState } from '../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import WTPMachineryChecklistDataPopup from './WTPPreventiveMachineryChecklistPopup'
import { WTPPreventiveMachineryChecklistExportData } from './WTPPreventiveMachineryChecklistExportData'
import { AstricSign } from '../../../../../Helper/AstricSign'

export default function WTPPreventiveMachineryChecklistPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails

    const dispatch = useDispatch()


    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WTPMachineryChecklistDataPopupShow, setWTPMachineryChecklistDataPopupShow] = useState(0)

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const date = moment().month(Month?.ID - 1).format('YYYY-MM-DD');

    const [Date, setDate] = useState(date ?? moment().format('YYYY-MM-DD'))

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [EquipmentName, setEquipmentName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WtpEquipmentType, setWtpEquipmentType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const handleAddOnClick = () => {
    //     setapiFlag('Insert')
    //     setWTPEquipmentTypeMasterPagePopupShow(true)
    // }

    const handleEditOnClick = (item) => {
        setWTPMachineryChecklistDataPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWTPMachineryChecklistDataPopupShow(false)
    }


    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setEquipmentName({
            ...EquipmentName,
            ID: 0,
            Label: 'Select...',
        })
        setWtpEquipmentType({
            ...WtpEquipmentType,
            ID: 0,
            Label: 'Select...',
        })

        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))
        setDate(date ?? moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            ReadingDate: Date,
            M_WTP_EquipmentTypeID: WtpEquipmentType.ID,
            M_WTP_EquipmentMasterID: EquipmentName.ID,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        dispatch(WTPMachineryChecklistTableDataAPI({ data }))
    }, [IsPost, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.WTPMachineryChecklistTableData)

    useEffect(() => {
        const data = {
            ReadingDate: Date,
            M_WTP_EquipmentTypeID: WtpEquipmentType.ID,
            M_WTP_EquipmentMasterID: EquipmentName.ID,
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(WTPMachineryChecklistTableExportDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.STPEnergyMPCNoTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WTP_MachineryChecklistID: item.t_wtP_MachineryChecklistID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(WTPMachineryChecklistDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WTPMachineryChecklistDelete)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Machinery Checklist</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            ExportTableData && ExportTableData.table && ExportTableData.table.length > 0 &&
                                            <WTPPreventiveMachineryChecklistExportData
                                                ExcelData={ExportTableData}
                                                name='Machinery Checklist'
                                                FromDate={Date}
                                                WardName={WardName.Label}
                                                EquipmentName={EquipmentName.Label}
                                                WtpEquipmentType={WtpEquipmentType.Label}
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-2 col-md-6">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Date <AstricSign /> </b></label>
                                                    <input
                                                        type='date'
                                                        className='form-control'
                                                        value={Date}
                                                        onChange={(e) => setDate(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-2 col-md-6">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WTPEquipmentTypeDDLData
                                                    WtpEquipmentType={WtpEquipmentType}
                                                    setWtpEquipmentType={setWtpEquipmentType}

                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WTPEquipmentNameDDL
                                                    EquipmentName={EquipmentName}
                                                    setEquipmentName={setEquipmentName}
                                                    WtpEquipmentType={WtpEquipmentType}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-12 col-lg-1 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-3">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        <th>Equipment Type</th>
                                                        <th>Equipment Name</th>
                                                        <th>Status</th>
                                                        <th>Remark</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td>{item.equipmentType ? item.equipmentType : '-'}</td>
                                                                <td>{item.equipmentDetails ? item.equipmentDetails : '-'}</td>
                                                                <td>{item.actionName ? item.actionName : '-'}</td>
                                                                <td>{item.remarks ? item.remarks : '-'}</td>
                                                                {/* <td></td> */}
                                                                <td style={{ textAlign: "center" }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WTPMachineryChecklistDataPopupShow ?
                        <WTPMachineryChecklistDataPopup
                            open={WTPMachineryChecklistDataPopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }

            </div>
        </div>



    )
}